import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { useStore } from '../../contexts/store-provider';
import { getUserId } from '../../helpers/localstorage-helper';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import RoutesConstants from '../../shared-components/routes/routes-constants';
import { formatMessage } from '../../translations/format-message';
import './operator.css';
import Header from '../../shared-components/header/header';
import ReorderProcess from '../../assets/Images/reorderProcess.svg';
import ReorderOperatorListDetail from './components/reorder-operator-list-detail';
import ReorderProcessPopupHOC from './hoc/reorder-operator-list-detail-hoc';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import noMessageIcon from '../../assets/Images/no-process.png';
import toast from 'react-hot-toast';

const OperatorListDetail = (props: any) => {
  const { operatorStore, activeTrayManagementStore } = useStore();
  const {
    getAssignedProcessListState,
    GetAssignedProcessListService,
    allAssignedTasks,
    resetCompleteProcessState,
  } = operatorStore;

  const { saveProcessOrderState, resetSaveProcessOrderState } =
    activeTrayManagementStore;

  const [selectedId, setSelectedId] = useState(0);

  const allAssignedTasksData = allAssignedTasks;

  const getAssignedTaskListServiceHandler = () => {
    GetAssignedProcessListService(
      Number(getUserId()),
      userSettingEnum.OperatorTaskOrder,
      userSettingEnum.HiddenProcessList
    );
  };

  const handleProcessReorderToggleHandler = (e) => {
    props.processReorderToggleHandler();
    // getActiveTrayListServiceHandler(createQueryString(filterObj));
  };

  const handleProcessReorderSubmit = () => {
    // setTimeout(() => {
    // }, 5000);
  };

  useEffect(() => {
    if (saveProcessOrderState.success) {
      toast.success(formatMessage('updated_success'))
      resetSaveProcessOrderState();
      GetAssignedProcessListService(
        Number(getUserId()),
        userSettingEnum.OperatorTaskOrder,
        userSettingEnum.HiddenProcessList
      );
    }
  }, [saveProcessOrderState.success]);

  useEffect(() => {
    getAssignedTaskListServiceHandler();
  }, []);

  return (
    <>
      {props.showReorderProcessPopup && (
        <ReorderOperatorListDetail
          id={selectedId}
          modalClosed={props.processReorderToggleHandler}
          processOptions={[]}
          onSubmitReorder={handleProcessReorderSubmit}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <Header
            className="col"
            label="operator_tasks"
          />
          <div className="col">
            <ul className="add-list">
              <li
                title={formatMessage('reorder_process')}
                className=""
              >
                <a
                  className="btn btn-primary"
                  data-toggle="modal"
                  data-testid="modalbtn"
                  data-target="#addUser"
                  onClick={handleProcessReorderToggleHandler}
                >
                  {' '}
                  <img
                    src={ReorderProcess}
                    alt=""
                    className="ReorderProcess me-1"
                  />
                  <FormattedMessage id="reorder_process" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="card card-body">
        <div className="operator-box operator-name pt-3">
          {getAssignedProcessListState.inProgress && (
            <FormLoader loading={getAssignedProcessListState.inProgress} />
          )}
          <div className="row tasks-list">
            {allAssignedTasksData && allAssignedTasksData.length > 0 ? (
              <>
            {allAssignedTasksData.map(
              ({ Id, ShortName, ProcessName, Type }) => {
                return (
                  <div
                    key={`${Id}-${Type}`}
                    className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 mb-2"
                  >
                    {Id > 0 ? (
                      <NavLink
                      title={formatMessage(ProcessName)}
                      to={`${RoutesConstants.OperatorAssignTask}/${Id}?processName=${ProcessName}&processType=${Type}`}
                      className="task-card"
                      //  <NavLink
                      //   title={formatMessage(ProcessName)}
                      //   to={
                      //     Id === 9991
                      //       ? `${RoutesConstants.Preprocessing}/${Id}?processName=${ProcessName}&processType=Demo`
                      //       : Id === 9992
                      //         ? `${RoutesConstants.Assembly}/${Id}?processName=${ProcessName}&processType=Rework`
                      //         : `${RoutesConstants.OperatorAssignTask}/${Id}?processName=${ProcessName}&processType=${Type}`
                      //   }
                      //   className="task-card"
                      >
                        {/* <div className="card-icon">
                          {ShortName.slice(0, 2).toLocaleUpperCase()}
                        </div> */}
                        <div className="card-title">
                          <FormattedMessage id={ProcessName} />
                        </div>
                      </NavLink>
                    ) : (
                      <NavLink
                        title={formatMessage(ProcessName)}
                        to={`${RoutesConstants.OperatorAssignSpecialTask}/${Id}?processName=${ProcessName}&processType=Special`}
                        className="task-card"
                      >
                        {/* <div className="card-icon">
                          {ShortName.slice(0, 2).toLocaleUpperCase()}
                        </div> */}
                        <div className="card-title">
                          <FormattedMessage id={ShortName} />
                        </div>
                      </NavLink>
                    )}
                  </div>
                );
              }
            )}
              </>
            ) : (
              <div className="message">
              <div className="d-flex message-area">
                <div className="no-data-img">
                  <img
                    src={noMessageIcon}
                    alt=""
                    className="no_message"
                  />
                </div>
                <div>
                  <h3 className="fw-bold display-6">
                    {' '}
                    <FormattedMessage id="no_process_assigned" />
                  </h3>
                  <h4 className="mb-3">
                    {formatMessage('no_process_assigned_message')}
                  </h4>
                </div>
              </div>
            </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ReorderProcessPopupHOC(observer(OperatorListDetail));
